import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  PLATFORM_ID,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER, MatTooltip } from '@angular/material/tooltip';
import { Subscription, timer } from 'rxjs';

@Directive({
  selector: '[sharryEllipsisTooltip]',
  standalone: true,
  providers: [MatTooltip, MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER],
})
export class EllipsisTooltipDirective implements AfterViewInit, OnChanges, OnDestroy {
  @Input() sharryEllipsisTooltip = '1';
  @Input() matTooltip = '';
  timer: Subscription = new Subscription();

  constructor(
    private _matTooltip: MatTooltip,
    private elementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
    const element = this.elementRef.nativeElement;
    if (!element.style.width) this.renderer.setStyle(element, 'width', '100%');
    this.renderer.setStyle(element, 'display', '-webkit-box');
    this.renderer.setStyle(element, '-webkit-line-clamp', this.sharryEllipsisTooltip || '1');
    this.renderer.setStyle(element, '-webkit-box-orient', 'vertical');
    this.renderer.setStyle(element, 'overflow', 'hidden');
    this.renderer.setStyle(element, 'overflow-wrap', 'anywhere');
    this.renderer.setStyle(element, 'white-space', 'normal');
    this._matTooltip.position = 'below';
    this._matTooltip.hideDelay = 300;
    this._matTooltip.tooltipClass = 'sharry-ellipsis-tooltip';
  }

  @HostListener('window:resize') checkOverflow() {
    const element = this.elementRef?.nativeElement;
    if (element) {
      this._matTooltip.disabled = element.scrollHeight - 1 <= element.clientHeight;
      this.renderer.setStyle(
        element,
        'cursor',
        element.scrollHeight - 1 <= element.clientHeight ? 'inherit' : 'pointer',
      );
    }
  }
  @HostListener('mouseover') onHover() {
    const element = this.elementRef?.nativeElement;
    if (element) {
      this._matTooltip.disabled = element.scrollHeight - 1 <= element.clientHeight;
      this.renderer.setStyle(
        element,
        'cursor',
        element.scrollHeight - 1 <= element.clientHeight ? 'inherit' : 'pointer',
      );
    }
    this._matTooltip.show();
  }
  @HostListener('mouseout') onNotHover() {
    this._matTooltip.hide(this._matTooltip.hideDelay);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.sharryEllipsisTooltip?.currentValue) {
      this.renderer.setStyle(
        this.elementRef.nativeElement,
        '-webkit-line-clamp',
        changes?.sharryEllipsisTooltip?.currentValue,
      );
      this.checkOverflow();
    }
    if (changes?.matTooltip?.currentValue) {
      this._matTooltip.message = this.matTooltip;
    }
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.timer = timer(100).subscribe(() => this.checkOverflow());
    }
  }

  ngOnDestroy() {
    this.timer.unsubscribe();
  }
}
